function CardList({children}) {
    return(
        <>
        {children}
        </>
    );
}

export { CardList }